import React, { useMemo, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import "../translations/i18n";
import Dropdown from 'rsuite/Dropdown';
import 'rsuite/dist/rsuite.min.css';
import { useCookies } from 'react-cookie';
import i18n from "i18next";
import getList from "../Redux/actions/CommonServices";
import { getTranslationSuccess } from '../Redux/actions/translationActions';
import { useDispatch, useSelector } from 'react-redux';
import { transLabel } from '../translations/util';
import { useMsal, AuthenticatedTemplate } from '@azure/msal-react';
import { clear } from '../Redux/api';

const Header = () => {
    const userRedux = useSelector(state => state.userReducer);
    const { instance, accounts } = useMsal();
    const [cookies, setCookie] = useCookies(['languaje']);
    const forceUpdate = React.useReducer(bool => !bool)[1];
    const translations = useSelector(state => state.translationReducer);
    const navigate = useNavigate();
    const toPage = (page) => {
      navigate(page)
    }

    console.log("userRedux", userRedux.data);
    const account = useMemo(() => accounts.filter(a => a.username.includes(process.env.REACT_APP_AAD_DOMAIN) || a.username.includes("atech-bpo")), [accounts])

    const dispatch = useDispatch();
    useEffect(() => {
        /*getList("Translations/Get", null, function (response) {
            if (!response) return;
            let lan = (cookies.languaje == null) ? "ES" : cookies.languaje;
            let filterTranslations = response.filter(c => c.lan == lan);
            //setTranslations(filterTranslations);
            dispatch(getTranslationSuccess(filterTranslations));
        });*/
    }, [cookies.languaje, dispatch]);

    const onSelectLanguaje = (newName) => {
        setCookie('languaje', newName, { path: '/' });
       /* getList("Translations/Get", null, function (response) {
            let filterTranslations = response.filter(c => c.lan == newName);
            //setTranslations(filterTranslations);
            dispatch(getTranslationSuccess(filterTranslations));
        });*/
    }

    /*useEffect(()=>{
        let lan = cookies.languaje;
        if (lan == null){
            lan = "ES";
        }
        i18n.changeLanguage(cookies.languaje);
    },[])*/

    const { t } = useTranslation();
    return (
        <>
            <header id="header">
                <div className="container-fluid pt-3" style={{height: '60px'}}>
                    <div className="brand float-start top-5 start-5">
                        <img src="assets/img/logo-positivo.svg?v=1.1" width={120} />
                    </div>
                    <div className="float-start">
                        <span className="brand-app">Tasking</span>
                    </div>
                    <div className="float-end account col-md-6 d-flex justify-content-start justify-content-md-end flex-wrap">
                            {/* <Dropdown onSelect={onSelectLanguaje} title={cookies.languaje} toggleClassName="dropTranslation">
                                <Dropdown.Item eventKey="ES">ES</Dropdown.Item>
                                <Dropdown.Item eventKey="EN">EN</Dropdown.Item>
                            </Dropdown> */}
                        <AuthenticatedTemplate>
                            <div className='d-flex align-items-center'>
                                <span className="text-light mx-4 desktop" title={account?.username ?? ''} style={{ fontSize: ".85rem" }}>
                                    {account.length > 0 && `${account[0].name}`}
                                </span>
                                <span className="text-light mx-3 smartphone" title={account?.username ?? ''} style={{ fontSize: ".85rem" }}>
                                    {account.length > 0 && `${account[0].name.substring(0,8) + '...'}`}
                                </span>
                            </div>
                            <div className='d-flex align-items-center' style={{ cursor: 'pointer' }} onClick={() => {
                                    clear();
                                    instance.logoutRedirect({
                                        account: instance.getAccountByUsername(account[0].name),
                                    });
                                }}>
                                <span style={{ fontFamily: "Material Icons", color: "rgb(248,249,250)", fontSize: "1.25rem" }}>logout</span>
                            </div>
                        </AuthenticatedTemplate>
                    </div>
                </div>
            </header>{/* End Header */}
        </>
    );
}

export default Header;
